// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type ChevronDown40Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const ChevronDown40: FC<ChevronDown40Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="40"
            height="40"
        >
            <path d="m32 17.238-12 9.828-12-9.828 2.014-2.476L20 22.932l9.986-8.17L32 17.238Z" />
        </svg>
    );
};

export default ChevronDown40;
